import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import { Apify, ApifyFullScreenLoadingComponent } from '../Apify';
import { TinyStockCard } from '../c/ChartCard';
import { T } from '../traks';

import SearchField from '../c/SearchField';
import { PortfolioExploreCard, StockExploreCard } from './Explore.js';
import { SponsorBanner } from '../c/SponsorBanner.js';

var ExploreXETRA = (props) => {
	var sections = [];

	const dax_name = <T>DAX 30</T>;
	const cars_name = <T>German cars</T>;

	sections.push(
		<Row key="vndjcgfbIUrgmj0i" className="align-items-center pt-5">
			<Col xs="12" className="pb-3">
				<h3 className="pt-5"><T>German collections</T></h3>
			</Col>
			<PortfolioExploreCard id={53876} card_img="/gfx/dax30-350x136-0.svg" name={dax_name} href="/portfolio/53876"/>
			<PortfolioExploreCard id={59595} card_img="/gfx/generic-cars-350x136-0.svg" name={cars_name} href="/portfolio/59595"/>
			<Container className="p-0">
				<SponsorBanner
					mode="iframe"
					sponsorName="Codan"
					iframeDesktopUrl="https://adops.bt.dk/stockgame/codan/desktop/index.html"
					iframeMobileUrl="https://adops.bt.dk/stockgame/codan/mobile/index.html"
				/>
			</Container>
			<Col xs="12" className="pb-3">
				<h3><T>Selected german stocks</T></h3>
			</Col>
			<StockExploreCard ticker="BMW" exchange="XETRA" card_img="/gfx/bmw-350x136-0.svg" name="BMW" href="/ticker/XETRA/BMW"/>
			<StockExploreCard ticker="BAYN" exchange="XETRA" card_img="/gfx/bayer-350x136-0.svg" name="Bayer" href="/ticker/XETRA/BAYN"/>
			<StockExploreCard ticker="VOW3" exchange="XETRA" card_img="/gfx/vw-350x136-0.svg" name="Volkswagen" href="/ticker/XETRA/VOW3"/>
			<StockExploreCard ticker="BOSS" exchange="XETRA" card_img="/gfx/boss-350x136-0.svg" name="Hugo Boss" href="/ticker/XETRA/BOSS"/>
			<StockExploreCard ticker="SIE" exchange="XETRA" card_img="/gfx/siemens-350x136-0.svg" name="Siemens" href="/ticker/XETRA/SIE"/>
			<StockExploreCard ticker="BAS" exchange="XETRA" card_img="/gfx/basf-350x136-0.svg" name="BASF" href="/ticker/XETRA/BAS"/>
			<StockExploreCard ticker="DPW" exchange="XETRA" card_img="/gfx/deutsche-post-350x136-0.svg" name="Deutsche Post" href="/ticker/XETRA/DPW"/>
			<StockExploreCard ticker="DTE" exchange="XETRA" card_img="/gfx/telekom-350x136-0.svg" name="Deutsche Telekom" href="/ticker/XETRA/DTE"/>
			<StockExploreCard ticker="TKA" exchange="XETRA" card_img="/gfx/thyssenkrupp-350x136-0.svg" name="ThyssenKrupp" href="/ticker/XETRA/TKA"/>
		</Row>

	);

	for (const section of props.home.Sections) {
		var items = [];

		const mk_stock_item = (asset) => {
			const key = `STOCK:${asset.Exchange}:${asset.Ticker}`;
			return (
				<Col key={key} className="pb-4 col-sm-6 col-md-6 col-xl-4 col-md-6 col-lg-4 col-12">
					<TinyStockCard
						exchange={asset.Exchange}
						ticker={asset.Ticker}
                        name={asset.Name}
						range="3m"
					/>
				</Col>
			);
		};

		switch (section.Type) {
			case "STOCKS":
				items = section.Content.map(mk_stock_item);
				break;
			default:
				continue;
		}
		sections.push(
				<span key="SPANNING_ALL">
				<Row key={section.Type}>
					<Col xs="12" className="pb-3">
						<h3><T>Random german stocks</T></h3>
					</Col>
				</Row>
				<Row>
					{items}
				</Row>
				</span>
		);
	}

	const placeholder = <T>Search German assets</T>;

	return (
		<React.Fragment>
			<div className="d-flex flex-column p-5 text-center ad_game_box justify-content-center">
				<div className="ad_explore_txt_header"><T>Germany</T></div>
				<div className="pb-3 ad_explore_txt_subheader"><T>Explore assets exclusively from Germany</T></div>
				<SearchField placeholder={placeholder} market="DE_STOCK" form_classes="justify-content-center pt-2" input_classes="ad_search_explore_page ad_no_outline_focus" input_id="search_field_1"/>
			</div>
			<Container>
				{sections}
			</Container>
		</React.Fragment>
	);
}

ExploreXETRA = Apify("/z/explore?market=DE_STOCK")
	.with_response_prop("home")
	.wrap(ExploreXETRA, ApifyFullScreenLoadingComponent);

export default ExploreXETRA;



// WEBPACK FOOTER //
// ./src/p/ExploreXETRA.js